const cacheKeys = {
  all: ['contents'],
  list: () => [...cacheKeys.all, 'list'],
  rsvp: () => [...cacheKeys.list(), 'rsvp'],
  likes: () => [...cacheKeys.list(), 'likes'],
  bookmarks: () => [...cacheKeys.list(), 'bookmarks'],
  byId: (contentId) => [...cacheKeys.list(), contentId],
  comments: (contentId) => [...cacheKeys.byId(contentId), 'comments']
}

export default {
  endpoints: {
    contents: '/contents',
    contentId: (contentId) => `/contents/${contentId}`,
    boost: (contentId) => `/contents/${contentId}/boost`,
    likes: (contentId) => `/contents/${contentId}/likes`,
    bookmarks: (contentId) => `/contents/${contentId}/bookmarks`,
    status: (contentId) => `/contents/${contentId}/status`,
    comments: (contentId) => `/contents/${contentId}/comments`,
    claim: (contentId) => `/scratch/${contentId}/claims`,
    rsvp: (eventId) => `/events/${eventId}/rsvp`
  },
  cacheKeys
}
